import { combineReducers } from 'redux';
import {
  UPDATE_INTERIOR_INDEX,
  UPDATE_EXTERIOR_INDEX,
  TOGGLE_CONVERTIBLE_TOP,
} from '../actionTypes';

export const isConvertibleTopDown = (state, { type }) => {
  switch (type) {
    case TOGGLE_CONVERTIBLE_TOP:
      return !state;
    default:
      return state || false;
  }
};

export const interiorIndex = (state, { type, payload }) => {
  switch (type) {
    case UPDATE_INTERIOR_INDEX:
      return payload;
    default:
      return state || 0;
  }
};

export const exteriorIndex = (state, { type, payload }) => {
  switch (type) {
    case UPDATE_EXTERIOR_INDEX:
      return payload;
    default:
      return state || 0;
  }
};

export default combineReducers({
  isConvertibleTopDown,
  interiorIndex,
  exteriorIndex,
});
